export const TEACHER_YEAR_OPTIONS = [
  { id: 4, label: "Year 4" },
  { id: 5, label: "Year 5" },
  { id: 6, label: "Year 6" },
  { id: 7, label: "Year 7" },
  { id: 8, label: "Year 8" },
  { id: 9, label: "Year 9" },
];

const YEAR_LABEL_LOOKUP = new Map(
  TEACHER_YEAR_OPTIONS.map((option) => [String(option.id), option.label])
);
const SUPPORTED_TEACHER_YEAR_IDS = new Set(
  TEACHER_YEAR_OPTIONS.map((option) => option.id)
);

const YEAR_VALUE_KEYS = ["name", "title", "label", "year", "standard", "id", "value"];

const toTrimmedString = (value) =>
  value === null || typeof value === "undefined" ? "" : String(value).trim();

const normalizeTeacherYearValues = (value) => {
  if (Array.isArray(value)) {
    return value.flatMap((item) => normalizeTeacherYearValues(item));
  }

  if (value && typeof value === "object") {
    const matchedValue = YEAR_VALUE_KEYS.map((key) => value[key]).find((candidate) =>
      Boolean(toTrimmedString(candidate))
    );
    return matchedValue ? normalizeTeacherYearValues(matchedValue) : [];
  }

  const normalizedValue = toTrimmedString(value);
  if (!normalizedValue) return [];

  return normalizedValue
    .split(",")
    .map((item) => item.trim())
    .filter(Boolean);
};

export const normalizeTeacherYearId = (value) => {
  const normalizedValue = toTrimmedString(value);
  if (!normalizedValue) return null;

  if (/^foundation$/i.test(normalizedValue)) {
    return null;
  }

  const matchedYear = normalizedValue.match(/^year\s*(\d+)$/i);
  const numericValue = matchedYear ? Number(matchedYear[1]) : Number(normalizedValue);

  if (!Number.isFinite(numericValue) || !SUPPORTED_TEACHER_YEAR_IDS.has(numericValue)) {
    return null;
  }

  return numericValue;
};

export const filterSupportedTeacherYearIds = (value) => {
  const matchedIds = new Set(
    normalizeTeacherYearValues(value)
      .map((item) => normalizeTeacherYearId(item))
      .filter((item) => item !== null)
  );

  return TEACHER_YEAR_OPTIONS.map((option) => option.id).filter((id) =>
    matchedIds.has(id)
  );
};

export const formatTeacherYearLabel = (value) => {
  const normalizedYearId = normalizeTeacherYearId(value);
  return normalizedYearId === null
    ? ""
    : YEAR_LABEL_LOOKUP.get(String(normalizedYearId)) || "";
};

export const formatTeacherYearLabels = (value) =>
  filterSupportedTeacherYearIds(value)
    .map((item) => formatTeacherYearLabel(item))
    .filter(Boolean);
